<section>
  <h2>Firearm Information</h2>
  <div class="card mb-3" *removeIfNoPermission="canViewFTS">
    <div class="card-body">
      <h3 class="card-title h4">Trace Data</h3>
      <table class="temp-bs table table-sm table-bordered w-lg-75" aria-describedby="DataTable">
        <thead>
          <tr>
            <th scope="col">FTS ID</th>
            <th scope="col">Purchase Date</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="!gunDetailCustomFields?.FirearmTraceData?.length">
            <td colspan="2">No Trace Data found.</td>
          </tr>
          <tr *ngFor="let data of gunDetailCustomFields?.FirearmTraceData">
            <td>{{ data.FTSID }}</td>
            <td>{{ data?.PurchaseDate | date:"MM/dd/yyyy" }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="card">
    <div class="card-body">
      <h3 class="card-title h4">Crime Gun Fields</h3>
      <div class="row">
        <div class="col-sm-3 col-md-4">Obliterated serial number?</div>
        <div class="col-sm-9 col-md-8">{{ gunDetailCustomFields?.ObliteratedSerialNumber | booleanTransform }}</div>
        <div class="col-sm-3 col-md-4">Amended serial number:</div>
        <div class="col-sm-9 col-md-8">{{ gunDetailCustomFields?.AmendedSerialNumber }}</div>
        <div class="col-sm-3 col-md-4">Stolen gun?</div>
        <div class="col-sm-9 col-md-8">{{ gunDetailCustomFields?.IsStolenGun | booleanTransform }}</div>
        <div class="col-sm-3 col-md-4">Date when gun was stolen:</div>
        <div class="col-sm-9 col-md-8">{{ gunDetailCustomFields?. DateStolen | date:'MM/dd/yyyy'}}</div>
        <div class="col-sm-3 col-md-4">Agency state:</div>
        <div class="col-sm-9 col-md-8">{{ gunDetailCustomFields?.StateName }}</div>
        <div class="col-sm-3 col-md-4">LE Agency:</div>
        <div class="col-sm-9 col-md-8">{{ gunDetailCustomFields?.AgencyName }}</div>
        <div class="col-sm-3 col-md-4">LE Case #:</div>
        <div class="col-sm-9 col-md-8">{{ gunDetailCustomFields?.LECaseNumber }}</div>
        <div class="col-sm-3 col-md-4">Comments:</div>
        <div class="col-sm-9 col-md-8">{{ gunDetailCustomFields?.Comments }}</div>
      </div>
    </div>
  </div>
  <div>
    <button type="button" (click)="closeFirearmView.emit()" class="btn btn-active my-3">Close</button>
  </div>
</section>
